import { timerEl } from "./elements";
import store from "./store";

let timerInterval = null;
let timeLimit = 0;

export const setTimeLimit = (timeLimit_) => {
  timeLimit = timeLimit_;
  setSecondsPassed();
};

export const startTimerInterval = () => {
  if (timerInterval != null) {
    throw Error("Timer already running");
  }
  store.secondsPassed = 0;
  timerInterval = setInterval(() => {
    store.secondsPassed += 1;
    setSecondsPassed();
  }, 1000);
};

export const stopTimerInterval = () => {
  clearInterval(timerInterval);
  timerInterval = null;
};

export const resetTimerInterval = () => {
  stopTimerInterval();
  store.secondsPassed = 0;
  setSecondsPassed();
};

export function setSecondsPassed() {
  let timerDisplay = timeLimit - store.secondsPassed;
  const showProgress = true;
  if (showProgress) {
    if (timerDisplay >= 60 * 60 * 24) timerDisplay = "∞";
    else if (timerDisplay >= 60 * 60)
      timerDisplay = new Date(timerDisplay * 1000).toISOString().slice(11, 19);
    else
      timerDisplay = new Date(timerDisplay * 1000).toISOString().slice(14, 19);
    // else
    //   timerDisplay = new Date(store.secondsPassed * 1000)
    //     .toISOString()
    //     .slice(17, 19);
  }
  //   colorScoreEl.innerHTML = showProgress
  //     ? timerDisplay
  //     : translate("Color");
  timerEl.innerHTML = timerDisplay;
  //   colorScoreEl.style.cursor = showProgress ? "default" : "pointer";
  //   colorScoreEl.style.pointerEvents = showProgress ? "none" : "auto";
//   scoreLandscapeEl.innerHTML = showProgress ? timerDisplay : "";
//   scoreLandscapeEl.style.cursor = showProgress ? "default" : "pointer";
//   scoreLandscapeEl.style.pointerEvents = showProgress ? "none" : "auto";
}
